import { useEffect, useState } from "react";
import { Loader2, Save, ServerCog } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export default function PlatformSmtpPage() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/smtp").then((r) => setCfg({ host: "", port: 587, username: "", password: "", from: "", use_tls: true, ...r.data }))
      .catch(() => toast.error("Super admin access required"));
  }, []);

  const upd = (k) => (e) => setCfg({ ...cfg, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/smtp", { ...cfg, port: parseInt(cfg.port, 10) || 587 }); toast.success("Platform SMTP saved"); }
    catch { toast.error("Could not save"); } finally { setSaving(false); }
  };

  if (!cfg) return <Loader2 className="w-5 h-5 animate-spin text-accent" />;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="platform-smtp-page">
      <div>
        <h1 className="text-3xl text-foreground mb-1 flex items-center gap-2"><ServerCog className="w-6 h-6 text-accent" /> Platform SMTP</h1>
        <p className="text-muted-foreground text-sm">Default mail server for all hubs. Individual hubs can override this in their own Hub Settings.</p>
      </div>
      <div className="bg-card border border-border rounded-md p-6 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div><Label>SMTP host</Label><Input data-testid="smtp-host" value={cfg.host || ""} onChange={upd("host")} className="mt-1.5" placeholder="smtp.mailprovider.com" /></div>
          <div><Label>Port</Label><Input data-testid="smtp-port" type="number" value={cfg.port || ""} onChange={upd("port")} className="mt-1.5" placeholder="587" /></div>
        </div>
        <div><Label>Username</Label><Input data-testid="smtp-username" value={cfg.username || ""} onChange={upd("username")} className="mt-1.5" /></div>
        <div><Label>Password</Label><Input data-testid="smtp-password" type="password" value={cfg.password || ""} onChange={upd("password")} className="mt-1.5" /></div>
        <div><Label>From address</Label><Input data-testid="smtp-from" value={cfg.from || ""} onChange={upd("from")} className="mt-1.5" placeholder="stays@yourhotel.com" /></div>
        <div className="flex items-center justify-between"><Label>Use STARTTLS</Label><Switch checked={!!cfg.use_tls} onCheckedChange={(v) => setCfg({ ...cfg, use_tls: v })} data-testid="smtp-tls" /></div>
        <Button onClick={save} disabled={saving} data-testid="save-smtp-btn" className="bg-primary text-primary-foreground">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-2" /> Save</>}</Button>
      </div>
    </div>
  );
}
